{
  "crm.unassigned": "Niet toegewezen",
  "crm.unknown_person": "Onbekende collega",
  "crm.undo": "Ongedaan maken",
  "crm.clear_filters": "Filters wissen",
  "crm.assigned_to": "Toegewezen aan {name}",
  "crm.retry": "Opnieuw",
  "crm.refresh": "Verversen",
  "crm.timezone_hint": "Tijd van het kantoor ({zone})",
  "crm.readonly_title": "Alleen bekijken",
  "crm.readonly_body": "Met je rol kun je contacten, aanvragen en taken bekijken, maar niet wijzigen.",

  "crm.channel.unknown": "Onbekende bron",
  "crm.channel.with_detail": "{channel}: {detail}",
  "crm.channel.website": "Website",
  "crm.channel.portal": "Portaal",
  "crm.channel.email": "E-mail",
  "crm.channel.phone": "Telefoon",
  "crm.channel.manual": "Handmatig",
  "crm.channel.import": "Import",
  "crm.channel.seed": "Demodata",

  "crm.due.today": "Vandaag {time}",
  "crm.due.tomorrow": "Morgen {time}",
  "crm.due.yesterday": "Gisteren {time}",

  "crm.field.name": "Naam",
  "crm.field.email": "E-mail",
  "crm.field.phone": "Telefoon",
  "crm.field.language": "Taal",
  "crm.field.country": "Land",
  "crm.field.source": "Bron",
  "crm.field.owner": "Behandelaar",
  "crm.field.created": "Toegevoegd",
  "crm.field.retention": "Bewaren tot",
  "crm.field.reference": "Referentie voor de klant",

  "crm.leads.title": "Aanvragen",
  "crm.leads.count": "{count, plural, one {# aanvraag} other {# aanvragen}}",
  "crm.leads.search_label": "Aanvragen zoeken",
  "crm.leads.search_placeholder": "Naam, e-mail, woning of referentie",
  "crm.leads.status_open": "Alle behalve spam",
  "crm.leads.col_lead": "Aanvraag",
  "crm.leads.col_message": "Bericht",
  "crm.leads.col_received": "Ontvangen",
  "crm.leads.col_assignee": "Behandelaar",
  "crm.leads.col_status": "Status",
  "crm.leads.unknown_sender": "Onbekende afzender",
  "crm.leads.empty_title": "Nog geen aanvragen",
  "crm.leads.empty_body": "Aanvragen van je website en portalen komen hier binnen.",
  "crm.leads.empty_filtered_title": "Geen aanvragen met deze filters",
  "crm.leads.empty_filtered_body": "Pas de filters aan of wis ze om alle aanvragen te zien.",
  "crm.leads.scope_label": "Van wie",
  "crm.leads.scope_all": "Iedereen",
  "crm.leads.scope_mine": "Aan mij",
  "crm.leads.signal_overdue": "Reactietermijn verlopen ({when})",
  "crm.leads.signal_soon": "Reageren vóór {when}",
  "crm.leads.signal_spam": "Mogelijk spam: {reasons}",
  "crm.leads.empty_action": "Naar de website",
  "crm.leads.empty_mine_title": "Niets aan jou toegewezen",
  "crm.leads.empty_mine_body": "Nieuwe aanvragen voor jou verschijnen hier.",
  "crm.leads.show_everyone": "Alle aanvragen bekijken",
  "crm.leads.bulk_label": "Acties voor de selectie",
  "crm.leads.bulk_assign": "Toewijzen",
  "crm.leads.bulk_status": "Status",
  "crm.leads.bulk_other": "Overig",
  "crm.leads.assign_me": "Aan mij",
  "crm.leads.bulk_done": "{count, plural, one {# aanvraag bijgewerkt} other {# aanvragen bijgewerkt}}",
  "crm.leads.bulk_failed": "{count, plural, one {# aanvraag niet bijgewerkt} other {# aanvragen niet bijgewerkt}}",

  "crm.lead.title": "Aanvraag",
  "crm.lead.received_at": "ontvangen {date}",
  "crm.lead.not_found_title": "Aanvraag niet gevonden",
  "crm.lead.not_found_body": "Deze aanvraag bestaat niet (meer) of hoort bij een andere organisatie.",
  "crm.lead.field_status": "Status",
  "crm.lead.field_assignee": "Toegewezen aan",
  "crm.lead.status_changed": "Status gewijzigd naar {status}",
  "crm.lead.assigned": "Toegewezen aan {name}",
  "crm.lead.unassigned_done": "Toewijzing weggehaald",
  "crm.lead.mark_spam": "Als spam markeren",
  "crm.lead.marked_spam": "Gemarkeerd als spam",
  "crm.lead.not_spam": "Geen spam, terugzetten",
  "crm.lead.restored": "Aanvraag teruggezet in de inbox",
  "crm.lead.mark_contacted": "Contact gehad vastleggen",
  "crm.lead.contacted_done": "Eerste contact vastgelegd",
  "crm.lead.spam_title": "Gemarkeerd als spam",
  "crm.lead.spam_body": "Deze aanvraag staat niet in de gewone inbox. Zet hem terug als het een echte vraag is.",
  "crm.lead.suspect_title": "Mogelijk spam",
  "crm.lead.signal.honeypot": "verborgen veld ingevuld",
  "crm.lead.signal.tooFast": "formulier binnen enkele seconden verstuurd",
  "crm.lead.signal.linkHeavy": "veel links in het bericht",
  "crm.lead.overdue_title": "Reactietermijn verlopen",
  "crm.lead.overdue_body": "Reageren kon tot {deadline}. Leg het contact vast zodra je hebt gereageerd.",
  "crm.lead.preferred_times": "Voorkeur voor bezichtiging:",
  "crm.lead.seller_locality": "Plaats",
  "crm.lead.seller_kind": "Soort woning",
  "crm.lead.seller_price": "Vraagprijs (opgegeven)",
  "crm.lead.seller_timeline": "Wil verkopen",
  "crm.lead.contact": "Contactgegevens",
  "crm.lead.open_dossier": "Dossier openen",
  "crm.lead.property_unlinked": "Referentie {ref} opgegeven, maar niet gekoppeld aan een woning in BRES.",
  "crm.lead.follow_up": "Opvolging",
  "crm.lead.notes": "Notities",
  "crm.lead.consents": "Toestemmingen",
  "crm.lead.history": "Historie",
  "crm.lead.back_to_list": "Terug naar de lijst",
  "crm.lead.status_failed": "Status wijzigen is niet gelukt",
  "crm.lead.assign_failed": "Toewijzen is niet gelukt",
  "crm.lead.soon_title": "Reactietermijn verloopt bijna",
  "crm.lead.soon_body": "Reageer vóór {deadline}.",
  "crm.lead.no_follow_up": "Nog geen taak of afspraak.",

  "crm.seller.timeline.now": "Zo snel mogelijk",
  "crm.seller.timeline.3_months": "Binnen 3 maanden",
  "crm.seller.timeline.6_months": "Binnen 6 maanden",
  "crm.seller.timeline.exploring": "Oriënteert zich",

  "crm.history.received": "Aanvraag ontvangen via {source}",
  "crm.history.first_response": "Eerste reactie vastgelegd",
  "crm.history.status": "Status gewijzigd naar {status}",
  "crm.history.assigned": "Toegewezen aan {name}",
  "crm.history.unassigned": "Toewijzing weggehaald",
  "crm.history.task_created": "Taak gemaakt: {title}",
  "crm.history.task_done": "Taak afgerond: {title}",
  "crm.history.appointment_confirmed": "Afspraak vastgelegd",
  "crm.history.appointment_request": "Afspraakverzoek vastgelegd",
  "crm.history.notifications": "Meldingen",
  "crm.history.received_spam": "Aanvraag ontvangen via {source}, met spamvermoeden",
  "crm.history.notifications_queued": "{count, plural, one {# melding klaargezet} other {# meldingen klaargezet}}",

  "crm.notification.pending": "Melding wacht op verzending",
  "crm.notification.failed": "{count, plural, one {Verzenden mislukt na # poging} other {Verzenden mislukt na # pogingen}}",
  "crm.notification.dead": "Melding niet verstuurd",
  "crm.notification.state.pending": "In de wachtrij",
  "crm.notification.state.failed": "Wordt opnieuw geprobeerd",
  "crm.notification.state.dead": "Gestopt",

  "crm.contacts.title": "Contacten",
  "crm.contacts.count": "{count, plural, one {# contact} other {# contacten}}",
  "crm.contacts.new": "Contact toevoegen",
  "crm.contacts.search_label": "Contacten zoeken",
  "crm.contacts.search_placeholder": "Naam of e-mailadres",
  "crm.contacts.col_name": "Naam",
  "crm.contacts.col_source": "Bron",
  "crm.contacts.no_details": "Geen e-mail of telefoon",
  "crm.contacts.leads_count": "{count, plural, one {# aanvraag} other {# aanvragen}}",
  "crm.contacts.briefs_count": "{count, plural, one {# actieve woonwens} other {# actieve woonwensen}}",
  "crm.contacts.empty_title": "Nog geen contacten",
  "crm.contacts.empty_body": "Bij elke aanvraag ontstaat vanzelf een contact. Je kunt ook zelf iemand toevoegen.",
  "crm.contacts.empty_filtered_title": "Niemand gevonden",
  "crm.contacts.empty_filtered_body": "Geen contact met \"{q}\" in naam of e-mailadres.",
  "crm.contacts.new_title": "Contact toevoegen",
  "crm.contacts.create": "Contact opslaan",
  "crm.contacts.created": "{name} toegevoegd",
  "crm.contacts.possible_duplicate": "Let op: {name} heeft hetzelfde e-mailadres. Controleer of dit dezelfde persoon is.",
  "crm.contacts.locale_unknown": "Onbekend",
  "crm.contacts.country_hint": "Landcode van twee letters, bijvoorbeeld NL of GB",
  "crm.contacts.country_invalid": "Gebruik twee letters, bijvoorbeeld NL",
  "crm.contacts.email_invalid": "Vul een geldig e-mailadres in",
  "crm.contacts.roles_required": "Kies minstens één rol",
  "crm.contacts.count_capped": "{count}+ contacten",
  "crm.contacts.col_role": "Rol",
  "crm.contacts.col_activity": "Activiteit",
  "crm.contacts.col_owner": "Behandelaar",
  "crm.contacts.col_last": "Laatst actief",
  "crm.contacts.field_roles": "Rollen",

  "crm.contact_role.buyer": "Koper",
  "crm.contact_role.tenant": "Huurder",
  "crm.contact_role.owner": "Eigenaar",
  "crm.contact_role.seller": "Verkoper",
  "crm.contact_role.partner": "Partner",

  "crm.contact.title": "Contact",
  "crm.contact.not_found_title": "Contact niet gevonden",
  "crm.contact.not_found_body": "Dit contact bestaat niet (meer) of hoort bij een andere organisatie.",
  "crm.contact.back_to_list": "Naar alle contacten",
  "crm.contact.details": "Gegevens",
  "crm.contact.consents": "Toestemmingen",
  "crm.contact.sections": "Onderdelen van het dossier",
  "crm.contact.leads": "Aanvragen",
  "crm.contact.follow_up": "Opvolging",
  "crm.contact.briefs": "Woonwensen",
  "crm.contact.shortlists": "Selecties",
  "crm.contact.no_leads_title": "Geen aanvragen",
  "crm.contact.no_leads_body": "Dit contact heeft nog geen aanvraag gedaan via de website of een portaal.",
  "crm.contact.open_tasks": "Open taken",
  "crm.contact.closed_tasks": "Afgerond en geannuleerd",
  "crm.contact.appointments": "Afspraken",
  "crm.contact.no_appointments": "Nog geen afspraken.",
  "crm.contact.timeline": "Tijdlijn",
  "crm.contact.no_tasks": "Geen open taken.",

  "crm.tasks.title": "Taken",
  "crm.tasks.count": "{count, plural, one {# open taak} other {# open taken}}",
  "crm.tasks.new": "Taak maken",
  "crm.tasks.view_label": "Welke taken",
  "crm.tasks.view_mine": "Mijn taken",
  "crm.tasks.view_all": "Alle taken",
  "crm.tasks.bucket.overdue": "Te laat",
  "crm.tasks.bucket.today": "Vandaag",
  "crm.tasks.bucket.later": "Later",
  "crm.tasks.bucket.none": "Zonder datum",
  "crm.tasks.complete_label": "Afronden: {title}",
  "crm.tasks.actions_for": "Acties voor {title}",
  "crm.tasks.edit": "Wijzigen",
  "crm.tasks.cancel_task": "Taak annuleren",
  "crm.tasks.completed": "Taak afgerond",
  "crm.tasks.cancelled": "Taak geannuleerd",
  "crm.tasks.reopened": "Taak weer open",
  "crm.tasks.saved": "Taak opgeslagen",
  "crm.tasks.edit_title": "Taak wijzigen",
  "crm.tasks.save": "Wijzigingen opslaan",
  "crm.tasks.new_title": "Taak maken",
  "crm.tasks.new_for_lead": "Bij de aanvraag van {name}",
  "crm.tasks.new_for_contact": "Voor {name}",
  "crm.tasks.create": "Taak maken",
  "crm.tasks.created": "Taak gemaakt",
  "crm.tasks.field_title": "Wat moet er gebeuren?",
  "crm.tasks.field_kind": "Soort",
  "crm.tasks.field_priority": "Prioriteit",
  "crm.tasks.field_due": "Deadline",
  "crm.tasks.field_assignee": "Toegewezen aan",
  "crm.tasks.field_contact": "Contact",
  "crm.tasks.field_contact_placeholder": "Zoek op naam",
  "crm.tasks.default_title_lead": "Aanvraag van {name} beantwoorden",
  "crm.tasks.default_title_contact": "Contact opnemen met {name}",
  "crm.tasks.empty_mine_title": "Geen open taken voor jou",
  "crm.tasks.empty_mine_body": "Nieuwe aanvragen leveren vanzelf een taak op. Je kunt ook zelf een taak maken.",
  "crm.tasks.empty_mine_body_readonly": "Taken die aan jou worden toegewezen, verschijnen hier.",
  "crm.tasks.empty_all_title": "Geen open taken",
  "crm.tasks.empty_all_body": "Niemand in je team heeft open taken.",
  "crm.tasks.show_all": "Alle taken bekijken",
  "crm.tasks.search_label": "Taken zoeken",
  "crm.tasks.search_placeholder": "Taak of contact",
  "crm.tasks.priority_high": "Hoge prioriteit",
  "crm.tasks.reopen_label": "Weer openzetten: {title}",
  "crm.tasks.done_ago": "Afgerond {when}",
  "crm.tasks.state_cancelled": "Geannuleerd",
  "crm.tasks.complete_failed": "Afronden is niet gelukt",
  "crm.tasks.save_failed": "Taak opslaan is niet gelukt",
  "crm.tasks.empty_search_title": "Geen taken gevonden",
  "crm.tasks.empty_search_body": "Geen open taak met deze woorden in de titel of bij het contact.",

  "crm.task.kind.follow_up": "Opvolgen",
  "crm.task.kind.call": "Bellen",
  "crm.task.kind.viewing": "Bezichtiging",
  "crm.task.kind.document": "Document",
  "crm.task.kind.review": "Controleren",
  "crm.task.kind.mandate": "Verkoopopdracht",
  "crm.task.kind.other": "Overig",

  "crm.related.contact": "Contact",
  "crm.related.lead": "Aanvraag",
  "crm.related.property": "Woning",
  "crm.related.appointment": "Afspraak",
  "crm.related.import_run": "Import",
  "crm.related.localized_revision": "Vertaling",

  "crm.appointments.new": "Afspraak plannen",
  "crm.appointments.new_title": "Afspraak plannen",
  "crm.appointments.field_kind": "Soort afspraak",
  "crm.appointments.kind_confirmed_hint": "Tijd en medewerker staan vast",
  "crm.appointments.kind_request_hint": "Tijd nog afstemmen",
  "crm.appointments.field_property": "Woning",
  "crm.appointments.no_property": "Geen woning",
  "crm.appointments.field_start": "Begint om",
  "crm.appointments.field_duration": "Duur",
  "crm.appointments.minutes": "{count, plural, one {# minuut} other {# minuten}}",
  "crm.appointments.field_staff": "Medewerker",
  "crm.appointments.submit_confirmed": "Afspraak vastleggen",
  "crm.appointments.submit_request": "Verzoek vastleggen",
  "crm.appointments.created_confirmed": "Afspraak vastgelegd",
  "crm.appointments.created_request": "Afspraakverzoek vastgelegd",
  "crm.appointments.range": "{start} tot {end}",
  "crm.appointments.preferred": "Voorkeur: {slots}",
  "crm.appointments.no_time": "Nog geen tijd",

  "crm.appointment.kind.confirmed": "Bevestigde afspraak",
  "crm.appointment.kind.request": "Afspraakverzoek",
  "crm.appointment.status.requested": "Aangevraagd",
  "crm.appointment.status.confirmed": "Bevestigd",
  "crm.appointment.status.completed": "Afgerond",
  "crm.appointment.status.cancelled": "Geannuleerd",
  "crm.appointment.status.no_show": "Niet verschenen",

  "crm.notes.field": "Nieuwe notitie",
  "crm.notes.placeholder": "Alleen zichtbaar voor je team",
  "crm.notes.save": "Notitie opslaan",
  "crm.notes.saved": "Notitie opgeslagen",
  "crm.notes.none": "Nog geen notities.",
  "crm.notes.save_failed": "Notitie opslaan is niet gelukt",

  "crm.consent.service": "Contact over de aanvraag",
  "crm.consent.marketing_email": "Nieuws en aanbod per e-mail",
  "crm.consent.property_alerts": "Meldingen van nieuwe woningen",
  "crm.consent.none": "Geen toestemmingen vastgelegd.",
  "crm.consent.recorded_on": "Vastgelegd op {date}",
  "crm.consent.withdrawn_on": "Ingetrokken op {date}",
  "crm.consent.times": "{count, plural, one {# keer vastgelegd} other {# keer vastgelegd}}",
  "crm.consent.state_granted": "Gegeven",
  "crm.consent.state_refused": "Geweigerd",
  "crm.consent.state_withdrawn": "Ingetrokken",

  "crm.briefs.new": "Woonwens vastleggen",
  "crm.briefs.new_title": "Woonwens vastleggen",
  "crm.briefs.new_body": "Harde eisen sluiten woningen uit. Pluspunten bepalen alleen de volgorde.",
  "crm.briefs.create": "Woonwens opslaan",
  "crm.briefs.created": "Woonwens vastgelegd",
  "crm.briefs.field_offer": "Zoekt",
  "crm.briefs.field_budget_min": "Budget vanaf",
  "crm.briefs.field_budget_max": "Budget tot en met",
  "crm.briefs.budget_invalid": "Moet minstens even hoog zijn als het budget vanaf",
  "crm.briefs.field_areas": "Gebieden",
  "crm.briefs.field_areas_hint": "Een regio telt alle plaatsen daarin mee. Niets gekozen betekent overal.",
  "crm.briefs.field_kinds": "Soorten woning",
  "crm.briefs.field_kinds_hint": "Niets gekozen betekent elke soort.",
  "crm.briefs.field_bedrooms": "Minimaal slaapkamers",
  "crm.briefs.field_bathrooms": "Minimaal badkamers",
  "crm.briefs.field_built": "Minimaal woonoppervlak",
  "crm.briefs.field_must": "Vereist",
  "crm.briefs.field_must_hint": "Woningen zonder deze kenmerken vallen af.",
  "crm.briefs.field_nice": "Pluspunten",
  "crm.briefs.field_nice_hint": "Tellen mee in de volgorde, maar sluiten niets uit.",
  "crm.briefs.field_notes": "Toelichting",
  "crm.briefs.budget": "Budget",
  "crm.briefs.budget_range": "{min} tot {max}",
  "crm.briefs.budget_max": "Tot {max}",
  "crm.briefs.budget_min": "Vanaf {min}",
  "crm.briefs.budget_none": "Geen budget opgegeven",
  "crm.briefs.minimum": "Minimaal",
  "crm.briefs.min_bedrooms": "{count, plural, one {# slaapkamer} other {# slaapkamers}}",
  "crm.briefs.min_bathrooms": "{count, plural, one {# badkamer} other {# badkamers}}",
  "crm.briefs.any": "Geen voorkeur",
  "crm.briefs.unknown_area": "Onbekend gebied",
  "crm.briefs.empty_title": "Nog geen woonwens",
  "crm.briefs.empty_body": "Leg vast wat dit contact zoekt. Je ziet dan welke woningen passen en waarom.",
  "crm.briefs.recorded": "Vastgelegd",

  "crm.brief.status.active": "Actief",
  "crm.brief.status.paused": "Gepauzeerd",
  "crm.brief.status.closed": "Gesloten",

  "crm.matches.show": "Passende woningen tonen",
  "crm.matches.hide": "Passende woningen verbergen",
  "crm.matches.summary": "{count, plural, =0 {Geen van de {evaluated} beoordeelde woningen past} one {# van {evaluated} beoordeelde woningen past} other {# van {evaluated} beoordeelde woningen passen}}",
  "crm.matches.list_label": "Passende woningen",
  "crm.matches.why": "{met} van {total} punten",
  "crm.matches.untitled": "Nog zonder titel",
  "crm.matches.price_on_request": "Prijs op aanvraag",
  "crm.matches.not_on_website": "Niet op de website",
  "crm.matches.select_label": "{ref} opnemen in de selectie",
  "crm.matches.selected": "{count, plural, =0 {Niets geselecteerd} one {# woning geselecteerd} other {# woningen geselecteerd}}",
  "crm.matches.select_all": "Alles selecteren",
  "crm.matches.empty_title": "Geen passende woningen",
  "crm.matches.empty_body": "Geen beschikbare woning voldoet aan alle harde eisen. Verruim het budget, het gebied of de vereiste kenmerken.",

  "crm.match.status_met": "Beschikbaar",
  "crm.match.status_other": "Status: {status}",
  "crm.match.budget_met": "Binnen budget",
  "crm.match.budget_unknown": "Prijs op aanvraag",
  "crm.match.budget_currency": "Prijs in {currency}",
  "crm.match.area_met": "In gewenst gebied",
  "crm.match.area_unknown": "Gebied onbekend",
  "crm.match.kind_met": "Gewenste soort",
  "crm.match.bedrooms_met": "{count, plural, one {# slaapkamer} other {# slaapkamers}} (min. {wanted})",
  "crm.match.bedrooms_unknown": "Slaapkamers onbekend",
  "crm.match.bathrooms_met": "{count, plural, one {# badkamer} other {# badkamers}} (min. {wanted})",
  "crm.match.bathrooms_unknown": "Badkamers onbekend",
  "crm.match.built_met": "{actual} m² (min. {wanted} m²)",
  "crm.match.built_unknown": "Oppervlakte onbekend",
  "crm.match.must_met": "{feature} aanwezig",
  "crm.match.nice_met": "Pluspunt: {feature}",
  "crm.match.nice_missing": "Ontbreekt: {feature}",
  "crm.match.offer_other": "Ander soort aanbod",

  "crm.shortlists.create_from": "{count, plural, =0 {Selectie maken} one {Selectie maken met # woning} other {Selectie maken met # woningen}}",
  "crm.shortlists.new_title": "Selectie maken",
  "crm.shortlists.new_body": "{count, plural, one {# woning gaat in deze selectie.} other {# woningen gaan in deze selectie.}}",
  "crm.shortlists.field_title": "Naam van de selectie",
  "crm.shortlists.default_title": "Selectie voor {name}, {date}",
  "crm.shortlists.properties": "Woningen",
  "crm.shortlists.create": "Selectie opslaan",
  "crm.shortlists.created": "{count, plural, one {Selectie met # woning opgeslagen} other {Selectie met # woningen opgeslagen}}",
  "crm.shortlists.items": "{count, plural, one {# woning} other {# woningen}}",
  "crm.shortlists.empty_title": "Nog geen selecties",
  "crm.shortlists.empty_body": "Maak een selectie uit de passende woningen bij een woonwens en deel die met een link.",
  "crm.shortlists.go_to_briefs": "Naar woonwensen",
  "crm.shortlists.made": "Gemaakt",

  "crm.shares.new": "Deellink maken",
  "crm.shares.new_title": "Deellink maken",
  "crm.shares.field_locale": "Taal van de pagina",
  "crm.shares.field_locale_hint": "Alleen talen die live staan op de website.",
  "crm.shares.field_days": "Geldig (dagen)",
  "crm.shares.field_days_hint": "Verloopt op {date}",
  "crm.shares.field_days_range": "Kies tussen 1 en 90 dagen",
  "crm.shares.create": "Deellink maken",
  "crm.shares.ready_title": "Deellink klaar",
  "crm.shares.once_title": "Kopieer de link nu",
  "crm.shares.once_body": "BRES bewaart alleen een controlecode, niet de link zelf. Na sluiten kun je hem niet meer zien; maak dan een nieuwe.",
  "crm.shares.url_label": "Deellink",
  "crm.shares.copy": "Link kopiëren",
  "crm.shares.copied": "Link gekopieerd",
  "crm.shares.copy_failed": "Kopiëren lukte niet. Selecteer de link en kopieer hem zelf.",
  "crm.shares.done": "Klaar",
  "crm.shares.close_without_copy": "Sluiten zonder kopiëren",
  "crm.shares.expires_on": "Verloopt op {date}",
  "crm.shares.expired_on": "Verlopen op {date}",
  "crm.shares.revoked_on": "Ingetrokken op {date}",
  "crm.shares.views": "{count, plural, =0 {Nog niet bekeken} one {# keer bekeken} other {# keer bekeken}}",
  "crm.shares.link_in": "Link in het {language}",
  "crm.shares.revoke": "Intrekken",
  "crm.shares.revoke_title": "Deellink intrekken?",
  "crm.shares.revoke_body": "Wie de link in het {language} heeft, kan de selectie daarna niet meer openen. Dit kun je niet terugdraaien.",
  "crm.shares.revoke_confirm": "Deellink intrekken",
  "crm.shares.revoked": "Deellink ingetrokken",
  "crm.shares.title": "Deellinks",
  "crm.shares.revoke_failed": "Intrekken is niet gelukt",

  "crm.feature.private_pool": "Privézwembad",
  "crm.feature.communal_pool": "Gemeenschappelijk zwembad",
  "crm.feature.garden": "Tuin",
  "crm.feature.terrace": "Terras",
  "crm.feature.balcony": "Balkon",
  "crm.feature.roof_terrace": "Dakterras",
  "crm.feature.garage": "Garage",
  "crm.feature.parking": "Parkeerplaats",
  "crm.feature.storage_room": "Berging",
  "crm.feature.lift": "Lift",
  "crm.feature.air_conditioning": "Airconditioning",
  "crm.feature.heating": "Verwarming",
  "crm.feature.solar_panels": "Zonnepanelen",
  "crm.feature.fireplace": "Open haard",
  "crm.feature.fitted_kitchen": "Ingebouwde keuken",
  "crm.feature.furnished": "Gemeubileerd",
  "crm.feature.barbecue": "Barbecue",
  "crm.feature.gated_community": "Afgesloten complex",
  "crm.feature.sea_front": "Aan zee",
  "crm.feature.near_beach": "Bij het strand",
  "crm.feature.near_golf": "Bij een golfbaan",
  "crm.feature.wheelchair_accessible": "Rolstoeltoegankelijk",
  "crm.feature.fibre_internet": "Glasvezel",
  "crm.feature.water_deposit": "Watertank",
  "crm.feature.guest_apartment": "Gastenverblijf",
  "crm.feature.tourist_license": "Toeristische vergunning",


  "crm.timeline.lead": "{kind} via {source}",
  "crm.timeline.note": "Notitie van {name}",
  "crm.timeline.brief": "Woonwens vastgelegd: {offer}",
  "crm.timeline.shortlist": "Selectie gemaakt: {title}",
  "crm.timeline.consent_granted": "Toestemming gegeven: {purpose}",
  "crm.timeline.consent_refused": "Toestemming geweigerd: {purpose}",
  "crm.timeline.consent_withdrawn": "Toestemming ingetrokken: {purpose}",
  "crm.timeline.created": "Contact toegevoegd"
}
